import { connect } from 'react-redux';
import { 
  STANDARD_SUBSCRIPTION_PRICE_MONTHLY, STANDARD_SUBSCRIPTION_ADDITIONAL_USER_PRICE_MONTHLY, CREATE_STANDARD_SUBSCRIPTION_CHECKOUT, getSubscriptionActiveAdditionalUserCount,
  ADDITIONAL_USER_DESCRIPTION,
} from '../actions/types';
import { siteboardAction } from '../actions/defaultActions';

import Tooltip from './Tooltip';
import PushButton from './PushButton';

const SubscriptionPaymentCard = ({ _users, _userId, _subscriptions, siteboardAction }) => {
  let ownedSubscription = null;
  try {
    ownedSubscription = _subscriptions[_users[_userId].ownedSubscriptionId];
    if(_subscriptions[ownedSubscription.id].members[_userId].role !== 'Owner') {
      ownedSubscription = null;
    }
  } catch(error) {}

  const additionalUsers = getSubscriptionActiveAdditionalUserCount(ownedSubscription); // exclude the owner from additional users count
  const monthlyPrice = '$' + (STANDARD_SUBSCRIPTION_PRICE_MONTHLY + (additionalUsers * STANDARD_SUBSCRIPTION_ADDITIONAL_USER_PRICE_MONTHLY)) + '/month';
  const additionalUserEmails = [];
  if(ownedSubscription) {
    for(const userId in ownedSubscription.members) {
      if(ownedSubscription.members[userId].role === 'Owner') continue;
      if(!(userId in _users)) continue;
      additionalUserEmails.push(_users[userId].email);
    }
  }

  return (
    <div>
      <div className='max-w-screen-sm flex flex-col justify-center gap-y-6'>
        <div>
          <h2 className='flex justify-between font-bold text-[1.1em]'>
            <div>Standard Subscription</div>
            <div>{monthlyPrice}</div>
          </h2>
          <div className='flex justify-between pl-6 text-[#999]'>
            <div>Base Subscription Cost</div>
            <div>${STANDARD_SUBSCRIPTION_PRICE_MONTHLY}</div>
          </div>
          <div className='flex justify-between pl-6 text-[#999]'>
            <Tooltip align='left' tooltipContent={'' + additionalUserEmails.join(', ')}>
              <div className={additionalUserEmails.length > 0 ? 'underline decoration-dotted underline-offset-4 cursor-help' : ''}>{additionalUsers} Additional User{additionalUsers !== 1 ? 's' : ''} @ ${STANDARD_SUBSCRIPTION_ADDITIONAL_USER_PRICE_MONTHLY}</div>
            </Tooltip>
            <div>${additionalUsers*STANDARD_SUBSCRIPTION_ADDITIONAL_USER_PRICE_MONTHLY}</div>
          </div>
        </div>
        <div>
          <Tooltip align='left' tooltipContent={ADDITIONAL_USER_DESCRIPTION}>
            <h2 className='font-bold text-[1.1em] underline decoration-dotted underline-offset-4 cursor-help'>Additional Users</h2>
          </Tooltip>
          <div>
            The number of additional users you&apos;re charged for updates automatically as people are added or removed from your subscription, and the cost is adjusted based on how long each user was active.
          </div>
        </div>
        <div>
          <h2 className='font-bold text-[1.1em]'>Payment Processing with Stripe</h2>
          <div>We partner with Stripe to process your payment securely. When you click the "Continue to Payment" button below you'll be redirected to Stripe's secure checkout page. Once your payment is complete you'll be automatically brought back to {process.env.REACT_APP_WEBSITE_NAME}.</div>
        </div>
        <PushButton 
          textColor='white'
          bgColor='#471cff'
          hoverBgColor='#603aff'
          onClick={() => {
            siteboardAction(CREATE_STANDARD_SUBSCRIPTION_CHECKOUT, {}, (output) => {
              window.location.href = output.checkoutUrl;
            });
          }}
        >
         Continue to Payment 
        </PushButton>
      </div>
    </div>
  );
};

const mapStateToProps = state => { return {
  _users: state.serverSynced.users,
  _userId: state.localPersistent.userId,
  _subscriptions: state.serverSynced.subscriptions,
}};
export default connect(mapStateToProps, { siteboardAction })(SubscriptionPaymentCard);
